import { render, staticRenderFns } from "./GrupoPermissao.vue?vue&type=template&id=aa1410b0&"
import script from "./GrupoPermissao.vue?vue&type=script&lang=js&"
export * from "./GrupoPermissao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports